<template>
  <div class="college">
    <div class="page">
      <div class="page-name">
        <span>{{ form.id ? "编辑" : "创建" }}课程</span>
        <el-button
          type="text"
          size="small"
          class="to-back ml-md"
          @click="toBack"
        >
          <img
            :src="returnIcon"
            style="height: 12px; margin-right: 5px"
          />返回</el-button
        >
      </div>
      <div class="form-box" v-if="showPage">
        <el-form
          class="form"
          ref="courseForm"
          label-width="160px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="课程名称" prop="resTitle">
            <el-input
              v-model="form.resTitle"
              style="width: 400px"
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="课程介绍" prop="resDesc">
            <el-input
              type="textarea"
              v-model="form.resDesc"
              style="width: 400px"
              maxlength="200"
              :autosize="{ minRows: 5, maxRows: 8 }"
              show-word-limit
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="课程分类" prop="resType">
            <el-select
              v-model="form.resType"
              placeholder="请选择课程分类"
              clearable
            >
              <el-option
                v-for="item in typeList"
                :key="item.dicCode"
                :label="item.dicName"
                :value="item.dicCode"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="课程封面" prop="faceUrl">
            <uploader
              tipDesc="仅支持图片"
              style="display: inline-block"
              list-type="picture-card"
              :limit="1"
              accept=".jpg, .png,.jpeg"
              :maxSize="3 * 1024 * 1024"
              :file-list.sync="form.faceUrl"
            />
          </el-form-item>
          <el-form-item label="课程文件" prop="attach">
            <uploader
              style="display: inline-block"
              :multiple="false"
              :limit="1"
              accept=".xls,.mp4,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
              :maxSize="500 * 1024 * 1024"
              :file-list.sync="form.attach"
            />
          </el-form-item>
          <el-form-item label="预计时长" prop="duration" v-if="isShowInput">
            <div>
              <el-input-number
                v-model="form.duration"
                :min="1"
                :controls="false"
                size="small"
              ></el-input-number>
              <span style="margin-left: 12px">分钟</span>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">发布</el-button>
          </el-form-item></el-form
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import uploader from "@/components/school/uploader.vue";
export default {
  components: {
    uploader,
  },
  data() {
    return {
      returnIcon: require("@/assets/image/other/return.png"),
      showPage: true,
      typeList: [],
      form: {
        id: null,
        resCode: null,
        resTitle: "",
        resDesc: "",
        resType: "",
        faceUrl: [],
        attach: [],
      },
      rules: {
        resTitle: [
          { required: true, message: "请输入课程名称", trigger: "blur" },
        ],
        // resDesc: [
        //   { required: true, message: "请输入课程介绍", trigger: "blur" },
        // ],
        resType: [
          { required: true, message: "请选择课程类型", trigger: "blur" },
        ],
        faceUrl: [{ required: true, message: "请上传封面", trigger: "blur" }],
        attach: [
          { required: true, message: "请上传资源文件", trigger: "blur" },
        ],
        duration: [
          { required: true, message: "请输入预计时长", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    isShowInput() {
      if (
        this.form.attach &&
        this.form.attach.length > 0 &&
        this.form.attach[0].attachType &&
        ["xlsx", "xls", "doc", "docx", "pdf"].includes(
          this.form.attach[0].attachType
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    toBack() {
      this.$router.go(-1);
    },
    getData(resCode) {
      this.$axios
        .post(
          "/resource/getResourceInfoDetail",
          this.$qs.stringify({
            resCode,
            operatorId: this.userInfo.userId,
            schoolCode: this.userInfo.schoolCode,
          })
        )
        .then(({ data }) => {
          this.form.resTitle = data.resTitle;
          this.form.resDesc = data.resDesc;
          this.form.resType = data.resType;
          this.form.faceUrl = [{ url: data.faceUrl }];
          if (data.attachType == "video") {
            this.form.attach = [
              {
                url: data.attachUrl,
                attachType: data.attachType,
                attachName: data.attachName,
                attachSize: data.attachSize,
                duration: data.duration,
              },
            ];
          } else {
            this.form.attach = [
              {
                url: data.attachUrl,
                attachType: data.attachType,
                attachName: data.attachName,
                attachSize: data.attachSize,
                duration: data.duration,
              },
            ];
            this.form.duration = data.duration / 60;
          }
          this.form.resCode = data.resCode;
          this.form.id = data.id;
        });
    },
    onSubmit() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.showPage = false;
          let formData = JSON.parse(JSON.stringify(this.form));
          formData.schoolCode = this.userInfo.schoolCode;
          formData.operatorId = this.userInfo.userId;
          formData.faceUrl = formData.faceUrl[0].url;
          formData.attachName = formData.attach[0].attachName;
          if (
            formData.attach[0].attachType == "mp4" ||
            formData.attach[0].attachType == "video"
          ) {
            formData.attachType = "video";
          } else {
            formData.attachType = "doc";
          }
          formData.attachUrl = formData.attach[0].url;
          formData.attachSize = formData.attach[0]?.attachSize;
          if (!this.isShowInput) {
            formData.duration = this.form.attach[0]?.duration;
          } else {
            formData.duration = this.form.duration * 60;
          }
          if (this.form.resCode != null && this.form.id != null) {
            formData.resCode = this.form.resCode;
            formData.id = this.form.id;
          }
          formData.resType = null;
          this.$axios
            .post("/resource/saveOrUpdateResourceInfo", formData)
            .then(() => {
              this.$message.success("保存成功！");
              this.$router.go(-1);
            });
        }
      });
    },
  },
  mounted() {
    // this.$axios
    //   .get("/core/dic/getDictionaryList", {
    //     params: {
    //       dicType: "resType",
    //       schoolCode: this.userInfo.schoolCode,
    //     },
    //   })
    //   .then((res) => {
    //     this.typeList = res.data;
    //   });
  },
  created() {
    if (this.$route.query.resCode) {
      this.getData(this.$route.query.resCode);
    }
  },
};
</script>

<style scoped lang="less">
.college {
  height: unset;
}
.page-name {
  height: 48px;
  display: flex;
  justify-content: space-between;
  .to-back {
    height: 28px;
  }
}
.form-box {
  flex: 1;
  background: #fcfcfc;
  border: 1px solid #dfdfdf;
  .form {
    max-width: 800px;
    margin: 0 auto;
    padding: 15px 0 30px;
  }
}
</style>